import HttpClient, { HttpError, type HttpClientResponse } from '../HttpClient';

class Status {
  private httpBokaCustomer: HttpClient;

  public constructor(httpBokaCustomer: HttpClient) {
    this.httpBokaCustomer = httpBokaCustomer;
  }

  public getStatus = async (): Promise<
    | HttpClientResponse<string>
    | HttpError
    | { status: number; statusText: string }
  > => {
    try {
      return await this.httpBokaCustomer.get<string>('/greeting');
    } catch (error) {
      if (error instanceof HttpError) {
        return error;
      }
      return {
        status: 500,
        statusText: 'Unknown Error',
      };
    }
  };
}

export default Status;
